import { FAVORITE_LABEL_ID } from '../../gameSlice'

export enum BuiltInGameLabel {
  Recommand = 6,
  Manufacturer = 8,
  Favorite = FAVORITE_LABEL_ID,
  All = -1,
}
